import { ComponentType, lazy } from 'react';

import promiseRetry from 'promise-retry';

const loadable = <T>(loadFn: () => Promise<{ default: ComponentType<T> }>) =>
  lazy(() => promiseRetry((retry) => loadFn().catch(retry), { retries: 5, maxTimeout: 5000 }));

export default loadable;
